import { render, staticRenderFns } from "./NotificationsPaymentDetail.vue?vue&type=template&id=4afb12f4&web=true&"
import script from "./NotificationsPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationsPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports